import IconSvg from 'core/_legacy/icons/IconSvg'

const DotIcon = ({
  width = 15,
  height = 15,
  color = '#96A2C2',
  style = {}
}) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height,
      ...style
    }}
    className="icon icons8-Circle"
  >
    <g
      fill={color}
      stroke="none"
      strokeWidth="1"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeDasharray=""
      strokeDashoffset="0"
    >
      <g>
        <g>
          <path d="M0,50l0,-50l50,0l0,50z" fill="none" fontWeight="normal" />
          <path
            d="M25,42.5c-9.66498,0 -17.5,-7.83502 -17.5,-17.5l0,0c0,-9.66498 7.83502,-17.5 17.5,-17.5l0,0c9.66498,0 17.5,7.83502 17.5,17.5l0,0c0,9.66498 -7.83502,17.5 -17.5,17.5z"
            fill={color}
          />
          <g fill={color}>
            <path d="M25,1.31c-13.07143,0 -23.69,10.61857 -23.69,23.69c0,13.07143 10.61857,23.69 23.69,23.69c13.07143,0 23.69,-10.61857 23.69,-23.69c0,-13.07143 -10.61857,-23.69 -23.69,-23.69z M25,3.37c11.95812,0 21.63,9.67188 21.63,21.63c0,11.95812 -9.67188,21.63 -21.63,21.63c-11.95812,0 -21.63,-9.67188 -21.63,-21.63c0,-11.95812 9.67188,-21.63 21.63,-21.63z" />
          </g>
        </g>
      </g>
    </g>
  </IconSvg>
)

export default DotIcon
